import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/modules/auth/shared/auth.service';
import { ForgotPasswordService } from 'src/app/modules/auth/shared/forgot-password.service';
import { MessageService } from 'src/app/modules/core/services/message.service';
import { MetaDataService } from 'src/app/shared/services/meta-data.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  title = 'HomePage_Seo.title'

  home: any;
  params: any;
  model: NgbDateStruct;
  date: { year: number, month: number };
  displayMonths = 1;
  navigation = 'arrow';
  isBrowser = false;
  loadingState = false;

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private messageService: MessageService,
    private forgotPasswordPopup: ForgotPasswordService,
    private translateService:TranslateService,
    private metaDataService:MetaDataService


  ) { }
  slides: any = [];

  ngOnInit(): void {


    this.params = this.route['_routerState'].snapshot.root.queryParams;
    if (this.params.mode === 'verifyEmail') {
      this.verifyEmail(this.params.oobCode);
    }
    // /?mode=updatePassword&oobCode=4e-nrxn-goF773vP0pZ7ryAppUSvyC1JEwu_xED6c1wAAAF1tAO9Jg
    if (this.params.mode === 'resetPassword') {
      this.forgotPasswordPopup.show();
    }

   this.metaDataService.setMetadata(this.title,'HomePage_Seo.keywords_content','HomePage_Seo.description_content')
   this.metaDataService.setTwitterCard()

  }

  async verifyEmail(obbCode): Promise<any> {
    const rp = await this.authService.verifyEmail(obbCode);
    this.messageService.showPopup(this.translateService.instant(rp.message), 'alert', rp.success ? 'success' : 'error', 'p0Popup');
  }

  changeLoadingState(event): void {
    this.loadingState = true;
  }


}
